import React, { Component } from 'react';
import {
  Card,
  Descriptions,
  Row,
  Col,
  Modal,
  Button,
  Tag,
  Image,
  Spin,
  message,
  Typography,
  Space,
  Divider
} from 'antd';
import {
  ShoppingCartOutlined,
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  ArrowLeftOutlined
} from '@ant-design/icons';
import AccountHeader from '../Account/AccountHeader';
import '../Account/Account.css';
import {
  IMAGE_URL,
  COMMIT_FOR_ASSET,
  GET_PRODUCT_DETAIL,
  get_data_token,
} from '../../config/network';
import { withRouter } from 'react-router-dom';
import './product.css';

const { Title, Text } = Typography;
const { confirm } = Modal;

class ProductDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      product: {},
      loading: true,
      reserving: false,
      reserved: false
    };
  }

  componentDidMount() {
    this.loadProductDetails();
  }

  loadProductDetails = async () => {
    const { uniquekey } = this.props.match.params;
    try {
      const data = await get_data_token(GET_PRODUCT_DETAIL, { productId: uniquekey });
      this.setState({ 
        product: data,
        reserved: data.delivered === 1,
        loading: false 
      });
    } catch (err) {
      message.error('Failed to load product details: ' + err);
      this.setState({ loading: false });
    }
  };

  handleReserve = () => {
    const { product } = this.state;
    confirm({
      title: 'Reserve Product',
      icon: <ExclamationCircleOutlined />,
      content: 'Are you sure you want to reserve this product for pickup?',
      onOk: async () => {
        this.setState({ reserving: true });
        try {
          await get_data_token(COMMIT_FOR_ASSET, { productId: product.product_id });
          this.setState({ reserved: true });
          message.success('Product reserved successfully!');
        } catch (err) {
          message.error('Failed to reserve product: ' + err);
        } finally {
          this.setState({ reserving: false });
        }
      },
    });
  };

  getAvailabilityStatus = () => {
    const { product, reserved } = this.state;
    if (reserved) {
      return { status: 'Reserved', color: 'orange', icon: <CheckCircleOutlined /> };
    } else if (product.available > 0) {
      return { status: 'Available', color: 'green', icon: <CheckCircleOutlined /> };
    } else {
      return { status: 'Out of Stock', color: 'red', icon: <ExclamationCircleOutlined /> };
    }
  };

  render() {
    const { product, loading, reserving, reserved } = this.state;
    const { history } = this.props;

    if (loading) {
      return (
        <div>
          <div className="main">
            <AccountHeader page={"Product"} title="Product Details" />
            <div className="main-body" style={{ textAlign: 'center', padding: 50 }}>
              <Spin size="large" />
            </div>
          </div>
        </div>
      );
    }

    const availability = this.getAvailabilityStatus();
    const isAvailable = product.available > 0 && !reserved;

    return (
      <div className="dashboard-container">
        <AccountHeader 
          page={"Product"} 
          title={<span>Product Details</span>} 
        />
        
        <div className="dashboard-content">
          <Button 
            icon={<ArrowLeftOutlined />} 
            onClick={() => history.goBack()}
            style={{ marginBottom: 16 }}
          >
            Back to Products
          </Button>

          <Row gutter={[24, 24]}>
            <Col xs={24} lg={10}>
              <Card
                cover={
                  <div style={{ padding: 16, textAlign: 'center', backgroundColor: '#f5f5f5', minHeight: 300 }}>
                    <Image
                      width="100%"
                      src={IMAGE_URL + product.product_image}
                      alt={product.product_name}
                      style={{ maxHeight: 400, objectFit: 'contain' }}
                      fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3Ik1RUG8E+1CZHcRU4kOifFxGIHOhAuQoudsMMdGNyBzR3Y7A5s5w60W+hISWwn"
                    />
                  </div>
                }
                bordered
              >
                <Card.Meta
                  title={
                    <Title level={3} style={{ marginBottom: 0 }}>
                      {product.product_name}
                    </Title>
                  }
                  description={
                    <Space direction="vertical" size="small">
                      <Tag color={availability.color} icon={availability.icon}>
                        {availability.status}
                      </Tag>
                      <Text type="secondary">{product.manufacturer}</Text>
                    </Space>
                  }
                />
              </Card>
            </Col>

            <Col xs={24} lg={14}>
              <Card title="Product Information" bordered>
                <Descriptions
                  bordered
                  column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}
                  size="middle"
                >
                  <Descriptions.Item label="Product Name" span={2}>
                    <Text strong>{product.product_name}</Text>
                  </Descriptions.Item>
                  <Descriptions.Item label="Manufacturer">
                    {product.manufacturer}
                  </Descriptions.Item>
                  <Descriptions.Item label="Part Number">
                    {product.part_num}
                  </Descriptions.Item>
                  <Descriptions.Item label="Unit of Measure">
                    {product.uom}
                  </Descriptions.Item>
                  <Descriptions.Item label="Availability">
                    <Tag color={availability.color} icon={availability.icon}>
                      {availability.status}
                    </Tag>
                  </Descriptions.Item>
                  <Descriptions.Item label="Description" span={2}>
                    {product.product_desc}
                  </Descriptions.Item>
                  {product.instruction && (
                    <Descriptions.Item label="Instructions" span={2}>
                      <Text style={{ whiteSpace: 'pre-wrap' }}>
                        {product.instruction}
                      </Text>
                    </Descriptions.Item>
                  )}
                </Descriptions>

                <Divider />

                {reserved ? (
                  <div style={{ textAlign: 'center', padding: '20px 0' }}>
                    <Tag color="orange" style={{ fontSize: 16, padding: '8px 16px' }}>
                      <CheckCircleOutlined style={{ marginRight: 8 }} />
                      {product.delivered === 1 ? 'This product has been rented' : 'Reserved for pickup'}
                    </Tag>
                  </div>
                ) : product.available === 0 ? (
                  <div style={{ textAlign: 'center', padding: '20px 0' }}>
                    <Tag color="red" style={{ fontSize: 16, padding: '8px 16px' }}>
                      <ExclamationCircleOutlined style={{ marginRight: 8 }} />
                      This product is not available
                    </Tag>
                  </div>
                ) : null}

                <div style={{ textAlign: 'right', marginTop: 24 }}>
                  <Button
                    type="primary"
                    size="large"
                    icon={<ShoppingCartOutlined />}
                    onClick={this.handleReserve}
                    disabled={!isAvailable}
                    loading={reserving}
                    style={{ minWidth: 160 }}
                  >
                    {reserved ? 'Already Reserved' : 'Reserve for Pickup'}
                  </Button>
                </div>
              </Card>
            </Col>
          </Row>
        </div>
    </div>
    );
  }
}

export default withRouter(ProductDetails);
